import api from "@/services/api"
import { CaseDetails, CaseField, Permission } from "@/types"
import { CurrentUser } from "@/types/user"
import Vue from "vue"

export class DataObjectMethods {
	public static async addItem (caseField: CaseField, newValue: any, record: CaseDetails): Promise<void> {
		if (record!.id) {
			await api.updateCaseDataField(record!.id, caseField.field.id!, 1, newValue)
		} else {
			if (!caseField.value) {
				Vue.set(caseField, "value", [])
			}

			caseField.value.push(newValue)
			caseField.label = caseField.value.map((i: any) => i.label).join(", ")
		}
	}
	public static async updateItem (caseField: CaseField, updatedValue: any, record: CaseDetails): Promise<void> {
		if (record!.id) {
			await api.updateCaseDataField(record!.id, caseField.field.id!, 3, updatedValue)
		} else {
			if (caseField.value) {
				caseField.value.removeWhere((item: any) => item.id === updatedValue.id)
				caseField.value.push(updatedValue)

				caseField.label = caseField.value.map((i: any) => i.label).join(", ")
			}
		}
	}
	public static async removeItem (caseField: CaseField, newValue: any, record: CaseDetails): Promise<void> {
		if (record!.id) {
			await api.updateCaseDataField(record!.id, caseField.field.id!, 2, newValue)
		} else {
			if (caseField.value) {
				caseField.value.removeWhere((item: any) => item.id === newValue.id)
				caseField.label = caseField.value.map((i: any) => i.label).join(", ")
			}
		}
	}
}

export function getPermissionTeams (field: CaseField, permissionType: keyof Permission, record: CaseDetails): any[] {
	const sectionPermissions = record.sectionDetails &&
		record.sectionDetails[field.section] &&
		record.sectionDetails[field.section].permissions
		? record.sectionDetails[field.section].permissions
		: null

	if (sectionPermissions) {
		const caseSectionPermissions = record.isCase ? sectionPermissions.case : sectionPermissions.record
		if (caseSectionPermissions && caseSectionPermissions[permissionType] && caseSectionPermissions[permissionType].length > 0) {
			return caseSectionPermissions[permissionType]
		}
	}

	const permissions = field.permissions
		? record.isCase ? field.permissions.case : field.permissions.record
		: null
	if (permissions) {
		return permissions[permissionType]
	}

	if (field.field.permissions) {
		return (record.isCase ? field.field.permissions.case : field.field.permissions.record)[permissionType]
	}

	return []
}

export function hasEditPermission (field: CaseField, record: CaseDetails, canEditCase: boolean, me: CurrentUser) {
	if (!canEditCase || field.field.displayReadOnly) {
		return false
	}

	const teams = getPermissionTeams(field, "edit", record)
	if (!teams || teams.length === 0) {
		return true
	}

	return me.teams && teams.some(team => me.teams.find((myTeam: any) => myTeam.id === team.id))
}

export function hasViewPermission (field: CaseField, user: CurrentUser, currentCase: CaseDetails): boolean {
	if (!user) return false

	const teams = getPermissionTeams(field, "view", currentCase)
	if (!teams || teams.length === 0) {
		return true
	}

	return user.teams && teams.some(team => user.teams.find((myTeam: any) => myTeam.id === team.id))
}
